import omitBy from 'lodash.omitby';

import { SHUTTERBUG_ALBUM_EVENT_TYPE } from '../apps/pro/views/Album/EventShutterbugCreate/constants';
import { ALBUM_TYPE } from '../constants/albums';
import contextualStrings, {
  SHUTTERBUG_ALBUM_EVENT_TYPE_PREFIX,
} from '../strings/strings';
import {
  getAlbumSubtypeOnBasename,
  getAlbumTypeOnBasename,
} from './role-definitions';

const interpolateString = (string, values) => {
  if (!values) {
    return string;
  }

  return string.replace(/{([^{}]*)}/g, (match, key) => {
    const replacement = values[key];
    return typeof replacement === 'string' || typeof replacement === 'number'
      ? replacement
      : match;
  });
};

const getContextualString = config => {
  const options = {
    type: ALBUM_TYPE.PRO,
    strings: contextualStrings,
    ...omitBy(config, x => x == null),
  };

  const { id, basename, defaultMessage, values, strings, eventType } = options;
  let { type, subtype } = options;

  // If basename is provided override album subtype
  // with whatever is mapped for it
  if (basename) {
    type = getAlbumTypeOnBasename(basename);
    subtype = getAlbumSubtypeOnBasename(basename);
  }

  // If no subtype is found fallback to type.
  // Type always defaults to PRO even if not supplied
  const stringObjRef =
    // eventType might be the same as type/subtype, so added a const to manage.
    strings[`${SHUTTERBUG_ALBUM_EVENT_TYPE_PREFIX}${eventType}`] ||
    strings[subtype] ||
    strings[type];

  let stringRef = stringObjRef && stringObjRef[id];

  // If we can't find the string reference try to fallback to
  // the PRO type one last time.
  // if EventType is passed, will fall back to "Other" event type.
  if (!stringRef) {
    stringRef = eventType
      ? strings[
          `${SHUTTERBUG_ALBUM_EVENT_TYPE_PREFIX}${SHUTTERBUG_ALBUM_EVENT_TYPE.OTHER}`
        ][id]
      : strings[ALBUM_TYPE.PRO][id];
  }

  return interpolateString(stringRef || defaultMessage || id, values);
};

export { getContextualString, interpolateString };
